import { createTheme } from '@mui/material/styles';
import Colors from './constants/Colors';
import Typographies from './constants/Typographies';

// Augment the existing Material-UI theme palette type
// Define a custom palette type
declare module '@mui/material/styles/createPalette' {
  interface Palette {
    dark: {
      dark_1: string;
      dark_2: string;
      dark_3: string;
      'dark_3.05': string;
      dark_4: string;
      dark_5: string;
      dark_6: string;
    };
    white: {
      main: string;
      light: string;
      dark: string;
    };
  }
  interface PaletteOptions {
    dark?: {
      dark_1: string;
      dark_2: string;
      dark_3: string;
      'dark_3.05': string;
      dark_4: string;
      dark_5: string;
      dark_6: string;
    };
    white?: {
      main: string;
      light: string;
      dark: string;
    };
  }
}
const defaultTheme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: Colors.DANGER_SHADE },
      },
    },
  },
  palette: {
    mode: 'light',
    background: {
      default: Colors.COLOR_WHITE_3,
    },
    text: {
      primary: Colors.COLOR_DARK_2,
    },
    primary: {
      main: Colors.PRIMARY_MAIN,
      light: Colors.PRIMARY_SHADE,
      dark: Colors.PRIMARY_ACCENT,
    },
    secondary: {
      main: Colors.SECONDARY_MAIN,
      light: Colors.SECONDARY_SHADE,
    },
    warning: {
      main: Colors.WARNING_MAIN,
      light: Colors.WARNING_SHADE,
    },
    info: {
      main: Colors.COLOR_DARK_5,
    },
    error: {
      main: Colors.DANGER_MAIN,
      light: Colors.DANGER_SHADE,
    },
    dark: {
      dark_1: Colors.COLOR_DARK_1,
      dark_2: Colors.COLOR_DARK_2,
      dark_3: Colors.COLOR_DARK_3,
      'dark_3.05': Colors.COLOR_DARK_3_05,
      dark_4: Colors.COLOR_DARK_4,
      dark_5: Colors.COLOR_DARK_5,
      dark_6: Colors.COLOR_DARK_6,
    },
    white: {
      main: Colors.WHITE,
      light: Colors.COLOR_WHITE_TEXT,
      dark: Colors.COLOR_WHITE_2,
    },
  },
  typography: {
    fontFamily: Typographies.FONT_FAMILY_MAIN,
    body1: {
      fontSize: Typographies.FONT_SIZE_BODY,
      fontWeight: Typographies.FONT_WEIGHT_BODY,
    },
    caption: {
      fontSize: Typographies.FONT_SIZE_CAPTION,
      fontWeight: Typographies.FONT_WEIGHT_CAPTION,
      color: Colors.COLOR_DARK_4,
    },
    h1: {
      fontSize: Typographies.FONT_SIZE_H1,
      fontWeight: Typographies.FONT_WEIGHT_H1,
    },
    h2: {
      fontSize: Typographies.FONT_SIZE_H2,
      fontWeight: Typographies.FONT_WEIGHT_H2,
    },
    h3: {
      fontSize: Typographies.FONT_SIZE_H3,
      fontWeight: Typographies.FONT_WEIGHT_H3,
    },
    h4: {
      fontSize: Typographies.FONT_SIZE_H4,
      fontWeight: Typographies.FONT_WEIGHT_H4,
    },
  },
  transitions: {
    duration: {
      short: 0.2,
    },
  },
});

export default defaultTheme;
